import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';
import SettingsSidebar from '../sidebar/SettingsSidebar';

// Actions
import { updateProfile, getUser } from '../../actions/auth';

// CSS
import '../../css/landing/landing.css';
import '../../css/userDetails/apiKey.css';

const ApiKey = ({
  auth: { isAuthenticated, user },
  getUser,
  updateProfile,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [apiKeyData, setApiKeyData] = useState(null);

  // Fetch API Key on page load
  useEffect(() => {
    const fetchAPIKey = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URI}/ecomnext/api/get-api-key`
        );

        if (response.data?.data) {
          setApiKeyData(response.data.data); // Save API key data
        }
      } catch (error) {
        console.error('Error fetching API key:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAPIKey();
  }, []);

  // Handle Generate Key button click
  const handleGenerateKey = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/ecomnext/api/generate-api-key`
      );

      if (response.data?.data) {
        setApiKeyData(response.data.data);
        toast.success('API key generated successfully!');
      } else {
        toast.error('Failed to retrieve API key.');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to generate API key.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopyKey = (key) => {
    navigator.clipboard.writeText(key);
    toast.success('Copied to clipboard!');
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <SettingsSidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <Navbar />

            {/* Main Content */}
            <div className='api-key-page-wrapper flex-1 bg-white p-6'>
              <h1 className='api-key-page-heading'>API Key</h1>
              <hr />

              {/* API Key Table */}
              {apiKeyData ? (
                <div className='mt-6 shadow-lg overflow-hidden rounded-lg'>
                  <table className='w-full text-left'>
                    <thead className='api-key-table-head border-b border-gray-200 tracking-wider'>
                      <tr>
                        <th className='py-3 px-4 font-medium'>Key ID</th>
                        <th className='py-3 px-4 font-medium'>API Key</th>
                        <th className='py-3 px-4 font-medium'>Created At</th>
                        <th className='py-3 px-4 font-medium'>Actions</th>
                      </tr>
                    </thead>
                    <tbody className='text-gray-600 text-sm divide-y divide-gray-200'>
                      <tr>
                        <td className='py-3 px-4'>
                          <div className='flex space-x-4'>
                            <div>{apiKeyData.key_id || 'N/A'}</div>
                            <button
                              className='text-green-600 hover:underline text-sm font-medium focus:outline-none'
                              onClick={() => handleCopyKey(apiKeyData.key_id)}
                            >
                              <i className='fas fa-copy mr-1'></i> Copy
                            </button>
                          </div>
                        </td>

                        <td className='py-3 px-4'>
                          <div className='flex space-x-4'>
                            <div>{apiKeyData.api_key}</div>
                            <button
                              className='text-green-600 hover:underline text-sm font-medium focus:outline-none'
                              onClick={() => handleCopyKey(apiKeyData.api_key)}
                            >
                              <i className='fas fa-copy mr-1'></i> Copy
                            </button>
                          </div>
                        </td>

                        <td className='py-3 px-4'>
                          {new Date(apiKeyData.created_at).toLocaleString()}
                        </td>

                        <td className='py-3 px-4'>
                          <button
                            className='text-blue-600 hover:underline text-sm font-medium'
                            onClick={handleGenerateKey}
                          >
                            <i className='fas fa-sync-alt mr-1'></i> Regenerate
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className='mt-3'>
                  <p className='api-key-generate-text'>
                    For security, ensure your API key remains private and is not
                    shared or exposed in browser scripts or client-side code.
                  </p>
                  <p className='mt-2 api-key-generate-text'>
                    To safeguard your account, Ecomnext may automatically
                    deactivate any API key detected as publicly exposed.
                  </p>

                  <div className='mt-4 flex justify-center'>
                    <button
                      className='px-6 py-2.5 api-key-generate-button transition-all'
                      onClick={handleGenerateKey}
                    >
                      <i className='fa-solid fa-plus mr-2'></i> Generate Key
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getUser, updateProfile })(ApiKey);
